<template>
  <v-container grid-list-xl>
    <h1 class="display-1">Prüfung hinzufügen</h1>
    <v-alert :value="errorMessage" type="error">
      {{ errorMessage }}
    </v-alert>
    <v-layout row wrap>
      <v-flex xs12 v-if="prüfung == null">
        <v-text-field
          solo
          placeholder="Prüfung suchen..."
          v-model="searchPrüfung"
        />
        <v-alert
          :value="
            !isLoading && (searchPrüfung || '').length > 1 && !prüfungen.length
          "
          type="info"
        >
          Keine Prüfung gefunden
        </v-alert>
        <v-data-table
          :headers="headers"
          :items="prüfungen"
          :loading="isLoading"
          :rows-per-page-items="[10, 25, 50, { text: 'Alle', value: -1 }]"
          v-if="(searchPrüfung || '').length && prüfungen.length"
        >
          <template v-slot:items="props">
            <tr @click="selectPrüfung(props.item)">
              <td>{{ props.item.Veranstaltung }}</td>
              <td>{{ props.item.Veranstaltungsort }}</td>
              <td>{{ formatDate(props.item.von) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="prüfung">
      <v-flex xs12>
        <h2>
          {{ prüfung.Veranstaltung }}
          <v-icon @click="clearPrüfung()">close</v-icon>
        </h2>
        <h3 class="grey--text">
          {{ prüfung.Veranstaltungsort }} -
          {{ formatDate(prüfung.von) }}
        </h3>
      </v-flex>
      <v-flex xs4>
        <v-list subheader class="elevation-2">
          <v-subheader class="title">Sets</v-subheader>
          <v-list-tile
            v-for="item in availableSets"
            :key="item.ID"
            :class="{ 'primary--text': selectedSet.ID == item.ID }"
            @click="selectSet(item)"
          >
            <v-list-tile-content>
              <v-list-tile-title v-text="item.Bezeichnung"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-avatar>
              {{ item.anzahlNichtGesperrt }}
            </v-list-tile-avatar>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex xs4 v-if="selectedSet.ID">
        <v-list subheader class="elevation-2">
          <v-subheader class="title">Prüfungsstücke</v-subheader>

          <v-alert
            :value="
              !isLoading &&
                selectedSet.ID &&
                (!selectedSet.stücke || !selectedSet.stücke.length)
            "
            color="info"
            icon="info"
            outline
          >
            Keine Stücke vorhanden
          </v-alert>

          <v-list-tile
            v-for="item in selectedSet.stücke"
            :key="item.ID"
            @click=""
          >
            <v-list-tile-action>
              <v-checkbox
                v-model="selectedStücke"
                :label="item.PrfStkNr"
                :value="item"
                :value-comparator="(i1, i2) => i1.ID == i2.ID"
                return-object
              ></v-checkbox>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex xs4 v-if="selectedItems.length">
        <v-card>
          <v-card-title
            ><span class="title grey--text text--darken-1"
              >Ausgewählt</span
            ></v-card-title
          >
          <v-list
            subheader
            v-for="item in selectedItems"
            :key="item.set.ID"
            @click=""
          >
            <v-subheader>{{ item.set.Bezeichnung }}</v-subheader>

            <v-list-tile v-for="subItem in item.items" :key="subItem.PrfStkNr">
              <v-list-tile-content>
                <v-list-tile-title
                  v-text="subItem.PrfStkNr"
                ></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-actions>
            <v-btn
              flat
              color="primary"
              v-if="selectedItems.length"
              @click="savePrüfung()"
              >Speichern</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="showSnackbar"
      :right="true"
      :timeout="6000"
      :top="true"
    >
      Prüfung gespeichert
      <v-btn color="pink" flat @click="showSnackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import debounce from 'lodash.debounce';
import orderby from 'lodash.orderby';
import groupby from 'lodash.groupby';

export default {
  name: 'AddExamPage',
  data() {
    return {
      isLoading: false,
      errorMessage: '',
      headers: [
        { text: 'Veranstaltung', value: 'Veranstaltung' },
        { text: 'Ort', value: 'Veranstaltungsort' },
        { text: 'Datum', value: 'von' }
      ],
      prüfungen: [],
      searchPrüfung: null,
      prüfung: null,
      availableSets: [],
      selectedSet: {},
      selectedStücke: [],
      showSnackbar: false
    };
  },
  methods: {
    loadPrüfungen: debounce(function(term) {
      this.isLoading = true;
      this.$http
        .get(`pruefung/search?term=${term}`)
        .then(resp => {
          this.prüfungen = resp.body || [];
        })
        .finally(() => (this.isLoading = false));
    }, 600),
    selectPrüfung(item) {
      this.prüfung = item;
      this.$http.get(`pruefungsset?verfahren=${item.verfahren}`).then(resp => {
        this.availableSets = orderby(resp.body, 'Bezeichnung') || [];
      });
    },
    loadStücke(setId) {
      this.isLoading = true;
      this.$http
        .get(`pruefungsstueck?setId=${setId}`)
        .then(resp => {
          if (this.selectedSet.ID == setId) {
            let stücke = resp.body.filter(f => !f.Gesperrt);
            this.$set(this.selectedSet, 'stücke', orderby(stücke, 'PrfStkNr'));
          }
        })
        .finally(() => (this.isLoading = false));
    },
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleDateString('de-DE');
    },
    selectSet(set) {
      this.selectedSet = set;
      if (!set.stücke) {
        this.loadStücke(set.ID);
      }
    },
    clearPrüfung() {
      this.prüfung = null;
      this.availableSets = [];
      this.selectedSet = {};
      this.selectedStücke = [];
      this.searchPrüfung = '';
    },
    savePrüfung() {
      let toSave = {
        prüfungId: this.prüfung.V_ID,
        stücke: this.selectedStücke.map(m => m.ID)
      };

      this.$http
        .post('pruefung/new', toSave)
        .then(resp => {
          this.showSnackbar = true;
          this.clearPrüfung();
        })
        .catch(err => {
          this.errorMessage = err;
        });
    }
  },
  computed: {
    selectedItems() {
      let selected = this.selectedStücke;
      let sets = this.availableSets;
      let groups = groupby(selected, 'setID');

      let grouped = Object.keys(groups).map(d => {
        let set = sets.find(f => f.ID === Number(d));

        return {
          set: set,
          items: orderby(groups[d], 'PrfStkNr')
        };
      });

      return orderby(grouped, 'set.Bezeichnung');
    }
  },
  watch: {
    searchPrüfung(value) {
      if (!value) {
        return;
      }
      this.isLoading = true;
      this.loadPrüfungen(value);
    }
  }
};
</script>
